import { AxiosResponse } from "axios";

import API from "../api";

import { Timezone } from "../models/timezone";

const ROUTE_NAME = "timezones";

const TimezoneService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Timezone>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Timezone[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(timezone: Timezone): Promise<AxiosResponse<Timezone>> {
    return await API.post(`/${ROUTE_NAME}`, timezone);
  },
  async update(id: number, timezone: Timezone): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, timezone);
  },
  async delete(id: number): Promise<AxiosResponse<Timezone>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default TimezoneService;
